import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import { EmbeddedCommunicationsManager } from '../../../../../src/api/embedded/EmbeddedCommunicationsManager'
import { Filters } from '../../../../../src/store/models/SearchModels'
import { useResultsStore } from '../../store/ResultsStore'
import { NonCachedSearchType } from 'interfaces'
import NoResults from './NoResults'
import HDNoResults from './HDNoResults'
import { useSearchFilterActions } from 'src/features/filterResults/useSearchFilterActions'
import { StoreInstances } from '../../../../../src/store/StoreInstancesContainer'

interface Props {
  filters: Filters
}

const NoResultsWrapper = observer((props: Props): ReactElement => {
  const { filters } = props

  const resultsStore = useResultsStore()
  const navigate = useNavigate()
  const { clearAllFilters } = useSearchFilterActions()
  const noResultsMessage =
    resultsStore.lastNonCachedSearch ===
    NonCachedSearchType.searchByAstNavigation
      ? 'tryANewSearchOrUseThePartsCatalog'
      : 'tryANewSearchOrEditYourFitmentConditions'

  const handleClearFilters = (): void => {
    clearAllFilters()
  }

  const goToAstPartsCatalog = () => {
    navigate('/astPartsCatalog')
  }

  const goToPartsCatalog = () => {
    navigate('/partsCatalog')
  }

  const HeaderText =
    filters.length > 0 ? 'yourFiltersReturnedNoResults' : 'noResultsFound'

  const BodyText =
    filters.length > 0 ? 'tryAdjustingYourFilters' : noResultsMessage

  const buttonText = filters.length > 0 ? 'clearFilters' : 'partsCatalog'

  const action =
    filters.length > 0
      ? handleClearFilters
      : EmbeddedCommunicationsManager.isAstPunchOut
        ? goToAstPartsCatalog
        : goToPartsCatalog

  const noResultsProps = {
    HeaderText,
    BodyText,
    buttonText,
    action,
  }

  if (
    resultsStore.lastNonCachedSearch ===
      NonCachedSearchType.searchByInterchange &&
    resultsStore.filters.length === 0
  ) {
    return (
      <HDNoResults
        partNumber={StoreInstances.searchStore.lastInterchangeTextSearched}
      />
    )
  }

  return <NoResults {...noResultsProps} />
})

export default NoResultsWrapper
